import { Space, Button, Alert, Divider } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useForceChangePassword } from "@/hooks/queries/user";
import { useAppNotification } from "@/modules/app-notification";
import { useSidePanel } from "@/modules/side-panel";

const ForceChangePassword = ({ user }) => {
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();
  const { notify } = useAppNotification();
  const [hasError, setHasError] = useState(false);
  const { id, name } = user;
  const mutation = useForceChangePassword(id);

  const onForceChangePassword = () => {
    mutation.mutate(null, {
      onSuccess: () => {
        notify.success({ title: t("user:forceChangePassword.success") });
        closeSidePanel();
      },
      onError: () => {
        setHasError(true);
      },
    });
  };

  return (
    <Space orientation="vertical">
      <Alert title={t("user:forceChangePassword.info", { name })} type="info" />
      {hasError && (
        <Alert
          type="error"
          closable
          closabl={{ onClose: () => setHasError(false) }}
          title={t("user:forceChangePassword.error")}
        />
      )}
      <Divider />
      <Space>
        <Button onClick={closeSidePanel}>{t("global:cancel")}</Button>
        <Button
          onClick={onForceChangePassword}
          loading={mutation.isPending}
          type="primary"
        >
          {t("user:forceChangePassword.button")}
        </Button>
      </Space>
    </Space>
  );
};

export default ForceChangePassword;
